import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LayoutService } from '../layout.service';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
    selector: 'purple-fit-tab-menu',
    templateUrl: './purple-fit-tab-menu.component.html',
    styleUrls: ['./purple-fit-tab-menu.component.scss'],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NzMenuModule, NzIconModule, RouterModule]
})
export class PurpleFitTabMenuComponent implements OnInit, AfterViewInit {

  constructor(public layoutSvc: LayoutService) { }
 

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      console.log('PurpleFitTabMenuComponent: ', this.layoutSvc.activeMenu);
      
    }, 1000);
  }

}
